<template>
  <div class="aside">
    <div class="aside__content">
      <img :src="`${config.publicPath}${imagePath}`" />
      <h2>
        <slot name="title" />
      </h2>
      <div>
        <ul class="aside__list">
          <slot name="list" />
        </ul>
      </div>
    </div>
    <div class="aside__footer">
      <ul class="aside__footer-list">
        <li><a :href="config.supportUrl" target="_blank">Support</a></li>
        <li><a :href="config.faqUrl" target="_blank">FAQ</a></li>
        <li>
          <a :href="config.privacyPolicyUrl" target="_blank">
            Privacy Policy
          </a>
        </li>
        <li><a :href="config.tosUrl" target="_blank">Terms of Use</a></li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { configService } from "@/services/config-service";

@Options({
  props: {
    imagePath: String,
    title: String,
  },
})
export default class AsideLayout extends Vue {
  config = configService;
}
</script>

<style lang="scss">
.aside {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 110px;

    img {
      width: 180px;
      margin-bottom: 60px;
    }

    h2 {
      font-size: 16px;
      margin: 0 0 35px;
      font-weight: 400;
    }
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
    color: var(--placeholder-text-color);

    li::marker {
      margin-top: 10px;
    }

    li {
      margin-bottom: 24px;
      padding-left: 30px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        margin-left: -30px;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/icon-add.svg") no-repeat;
      }
    }
  }

  &__footer {
    padding-top: 33px;
    border-top: 1px solid var(--border-color);
    width: 100%;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      color: var(--placeholder-text-color);

      a,
      a:link,
      a:visited,
      a:active,
      a:hover {
        color: var(--placeholder-text-color);
        font-weight: normal;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
